// extracted by mini-css-extract-plugin
module.exports = {"empty":"_19453","message":"_7932","actions":"_15870","noMargin":"_8919"};